import { render } from "./MyCampaigns.vue?vue&type=template&id=201316c8&scoped=true"
import script from "./MyCampaigns.vue?vue&type=script&lang=js"
export * from "./MyCampaigns.vue?vue&type=script&lang=js"

import "./MyCampaigns.vue?vue&type=style&index=0&id=201316c8&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201316c8"]])

export default __exports__